module.exports = __webpack_public_path__ + "media/educators/nassp-84a4c172.png";